import type { TagParser } from './tagParser';

export class ParserRegistry {
  private static processors = new Map<string, TagParser>();

  static register(processor: TagParser): void {
    this.processors.set(processor.tag, processor);
  }

  static getParser(tag: string): TagParser | undefined {
    return this.processors.get(tag);
  }
}
